import store from '../store/store';

export class LoadingPageData {
	
	constructor(page_to_load) {
		this.status = "none";
		
		this.uid = undefined;
		this.app = undefined;
		this.period = undefined;

		this.data_id_a = [];	
		
		this.php_scripts_js_a = [];
		this.php_scripts_a = [];
		
		this.php_post_data_js = {};
		this.extra_php_post_data_js_a = [];
		
		this.page_to_load = page_to_load;
		
		this.page_to_load_props_js = {};

		this.setLoginDataJs()
	}

	setLoginDataJs() {
		// See note 1 below
		this.status = "none";
		try {
			const st = store.getState().dataStates.data.login;
			if ( 
				(st !== undefined) &&
				(Object.keys(st).length > 0) 
				) {
					if ( st.status === "available" ) {
						let login_js = Object.assign({}, st.data.data_js);
						this.status = "available";
						this.uid = login_js.uid;
						this.app = login_js.app;
						this.period = login_js.period;
						this.setPhpPostDataJs();
					}
			}
		} catch(e) {
			console.log(`Err: LoadingPageData->setLoginDataJs. Login data not available`);
			this.status = "none";
		}
		
	}

	setPhpPostDataJs() {
		this.php_post_data_js = {
			uid: this.uid,
			app: this.app,
			period: this.period
		}
	}

	setDataIdPhpScriptPair( id, script_uri, extra_php_post_data_js = "none" ) {
		this.data_id_a.push(id);
		this.php_scripts_a.push(script_uri);
		// extra_php_post_data_js are extra parameters to pass to $_POST besides:
		// uid, app, period
		// e.g., could be a uniq to pass to $_POST
		// If "none", then it is ignored and just uid, app, period are passed to $_POST
		this.extra_php_post_data_js_a.push(extra_php_post_data_js);
	}

	setPageToLoadProps(js) {
		this.page_to_load_props_js = Object.assign( {}, js );
	}

	getData() {

		let result;
		let msg;
		let data;

		if ( Object.keys(this.php_post_data_js).length > 0 ) {
			if ( this.data_id_a.length > 0 ) {
				this.php_scripts_js_a = [];
				for ( var i = 0; i < this.data_id_a.length; i++ ) {
					let data_js = Object.assign({}, this.php_post_data_js);
					if ( this.extra_php_post_data_js_a[i] !== "none" ) {
						data_js = Object.assign(
							{},
							{...data_js, ...this.extra_php_post_data_js_a[i]}
						);
					}
					let js = {
						id: this.data_id_a[i],
						script_uri: this.php_scripts_a[i],
						data_js: data_js
					};
					this.php_scripts_js_a.push(js);
				}
			
			}
			
			result = true;
			msg = "available";
			data = {};
			data['data_id_a'] = this.data_id_a;
			data['php_scripts_js_a'] = this.php_scripts_js_a;
			data['page_to_load'] = this.page_to_load;
			data['page_to_load_props_js'] = this.page_to_load_props_js;	

		} else {
			result = false;
			msg = "Err: LoadingPageData->setDataIdPhpScriptPair. data_id_a not available";
			data = {};
		}

		let res = {}
		res['result'] = result;
		res['msg'] = msg;
		res['data'] = Object.assign( {}, data );
		return res;
		


	}


}

/*

Note: 1
Assumes this structure:
login: {
	status: 'available',
	data: {
	  token: '253622128051032',
	  result: true,
	  feedback: '<span style="color:#0D0DFF">ID and password are correct!</span>',
	  data_js: {
		date: '2021-07-08 15:21:12',
		uid: 'ab1',
		app: 'por112',
		period: 'Fall 2021',
		name_uid: 'Joe Collentine',
		name_app: 'POR 112 - First year Portuguese'
	  }
	}
  }

  */

/*

Note: 2

--------------------------------

This is a class whose instances can be passed to dispatch( setAppPage( { page: "loadingPage", props: loadingPageDataResults.data } ) )

- With the constructor, pass the name of the page to load referenced in App.js

- setDataIdPhpScriptPair: 
-- e.g., loadingPageData.setDataIdPhpScriptPair('app_data','php/app_data_get.php')
-- assumes that each script gets passed uid, app, period to $_POST

-- a third arg can have extra parameters to pass to $_POST
-- e.g., loadingPageData.setDataIdPhpScriptPair('app_data','php/app_data_get.php', {uniq: "por112-cap1-1"})

-- pass as many data ids and php scripts (that feed the id) to be stored in dataStates/data store
-- > loadingPageData.setDataIdPhpScriptPair(...)
-- > loadingPageData.setDataIdPhpScriptPair(...)


*** If you just want to load a page with no server calls, just instantiate the object and pass 
loadingPageDataResults.data to dispatch( setAppPage( { page: "loadingPage", props: loadingPageDataResults.data } ) )


--------------------------------


Typcal usage:

import { LoadingPageData } from '../classes/LoadingPageData';
...

const loadingPageData = new LoadingPageData("appPage");

loadingPageData.setDataIdPhpScriptPair('app_data','php/app_data_get.php');
loadingPageData.setDataIdPhpScriptPair('uid_data','php/uid_data_get.php');
const loadingPageDataResults = loadingPageData.getData();

if ( loadingPageDataResults.result ) {
	dispatch( setAppPage( 
		{ 	page: "loadingPage", 
			props: loadingPageDataResults.data
		}));
} else {
	console.log( "Err with loadingPageData " );
}

To just load a page without server data:

const loadingPageData = new LoadingPageData("helpPage");
const loadingPageDataResults = loadingPageData.getData();

if ( loadingPageDataResults.result ) {
	dispatch( setAppPage( 
		{ 	page: "loadingPage", 
			props: loadingPageDataResults.data
		}));
} else {
	console.log( "Err with loadingPageData " );
}

----------------------------

This class simplifies building a bunch of vars to pass to dispatch( setAppPage {page: "loadingPage", props: {...} })

const data_id_a = ['app_data','uid_data'];
const php_scripts_js_a = [
	{
		id: "app_data", script_uri: "php/app_data_get.php",
		data_js: { 
			uid:uid,
			app:login_js.data_js.app,
			period:login_js.data_js.period
		}
	},
	{
		id: "uid_data", script_uri: "php/uid_data_get.php",
		data_js: { 
			uid:uid,
			app:login_js.data_js.app,
			period:login_js.data_js.period
		}
	}					
];
const page_to_load = "appPage";
const page_to_load_props_js = {};





*/


